import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import SizeRadioButtons from './SizeRadioButtons';
import ClientProvider from './client';
export default createDemo(import.meta.url, SizeRadioButtons, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/radio-buttons/demos/size/SizeRadioButtons.tsx",
    "fileName": "SizeRadioButtons.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Radio from '@mui/material/Radio';\n\nexport default function SizeRadioButtons() {\n  const [selectedValue, setSelectedValue] = React.useState('a');\n  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {\n    setSelectedValue(event.target.value);\n  };\n\n  const controlProps = (item: string) => ({\n    checked: selectedValue === item,\n    onChange: handleChange,\n    value: item,\n    name: 'size-radio-button-demo',\n    slotProps: { input: { 'aria-label': item } },\n  });\n\n  return (\n    <div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Radio {...controlProps('a')} size=\"small\" />\n      <Radio {...controlProps('b')} />\n      <Radio\n        {...controlProps('c')}\n        sx={{\n          '& .MuiSvgIcon-root': {\n            fontSize: 28,\n          },\n        }}\n      />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 32,
        "focusedLines": 10,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Radio from '@mui/material/Radio';\n\nexport default function SizeRadioButtons() {\n  const [selectedValue, setSelectedValue] = React.useState('a');\n  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {\n    setSelectedValue(event.target.value);\n  };\n\n  const controlProps = (item: string) => ({\n    checked: selectedValue === item,\n    onChange: handleChange,\n    value: item,\n    name: 'size-radio-button-demo',\n    slotProps: { input: { 'aria-label': item } },\n  });\n\n  return (\n    <div>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Radio {...controlProps('a')} size=\"small\" />\n      <Radio {...controlProps('b')} />\n      <Radio\n        {...controlProps('c')}\n        sx={{\n          '& .MuiSvgIcon-root': {\n            fontSize: 28,\n          },\n        }}\n      />\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Radio"
              ],
              " ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-k di-pu",
                "..."
              ],
              [
                "span",
                "pl-en",
                "controlProps"
              ],
              "(",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "a",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              ")",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "size"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "small",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Radio"
              ],
              " ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-k di-pu",
                "..."
              ],
              [
                "span",
                "pl-en",
                "controlProps"
              ],
              "(",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "b",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              ")",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Radio"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "        ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-k di-pu",
                "..."
              ],
              [
                "span",
                "pl-en",
                "controlProps"
              ],
              "(",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "c",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              ")",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "          ",
              [
                "span",
                "pl-s di-op di-ps di-jv",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "& .MuiSvgIcon-root",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              ": {"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "            ",
              [
                "span",
                "di-op di-jv",
                "fontSize"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "28"
              ],
              ","
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 27
            },
            "          },"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            [
              "        }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 29
            },
            "      />"
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 32,
    "focusedLines": 10,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Radio"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
